// client/src/coms/components/mobile/useAutoHideNav.js
// "Auto-hide while scrolling": the bar steps aside while you read and comes back as soon as you scroll the other
// way or reach the newest messages. In a conversation reading means scrolling up into history; in lists (Chats,
// Activities, Settings) it means scrolling down.
import { useEffect, useState } from 'react';

export default function useAutoHideNav(enabled, rootRef, resetKey) {
  const [hidden, setHidden] = useState(false);

  // A new screen always starts with the bar visible.
  useEffect(() => {
    setHidden(false);
  }, [resetKey, enabled]);

  useEffect(() => {
    const root = rootRef.current;
    if (!enabled || !root) return undefined;
    const last = new WeakMap();
    const onScroll = (e) => {
      const el = e.target;
      if (!el || typeof el.closest !== 'function') return;
      // Sideways rows and the navigation itself never hide it.
      if (el.closest('[data-testid="mobile-nav"], .vx-mmenu, [data-coms-no-swipe="true"]')) return;
      const top = el.scrollTop;
      const prev = last.has(el) ? last.get(el) : top;
      last.set(el, top);
      const d = top - prev;
      if (Math.abs(d) < 8) return;
      const chat = el.classList.contains('coms-messages');
      const atRest = chat ? el.scrollHeight - el.clientHeight - top < 32 : top < 32;
      if (atRest) setHidden(false);
      else setHidden(chat ? d < 0 : d > 0);
    };
    root.addEventListener('scroll', onScroll, true);
    return () => root.removeEventListener('scroll', onScroll, true);
  }, [enabled, rootRef]);

  return enabled && hidden;
}
